import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

export { default as changeUsername } from './changeUsername';
export { default as deactivateAccount } from './deactivateAccount';
export { default as fetch } from './fetch';
export { default as linkEmailToAccount } from './linkEmailToAcccount';
export { default as requestPasswordReset } from './requestPasswordReset';
export { default as resetPassword } from './resetPassword';
export { default as saveMessagePreferences } from './saveMessagePreferences';
export { default as saveMessageVia } from './saveMessageVia';
export { default as unlinkSocialAccount } from './unlinkSocialAccount';

const service = new SettingsService();

export const toggleNotificationDialog = () => ({
  type: SettingsActionTypes.TOGGLE_NOTIFICATION_DIALOG,
});

/** ----------------------------------------------------------------------------
 * UPDATE MESSAGE PREFRENCES
 -----------------------------------------------------------------------------*/
export const updateMessagePreferences = messagePreferences => ({
  type: SettingsActionTypes.UPDATE_MESSAGE_PREFERENCES,
  preferences: messagePreferences,
});

export const toggleUsernameDialog = () => ({
  type: SettingsActionTypes.TOGGLE_USERNAME_DIALOG,
});

export const toggleDeactivateDialog = () => ({
  type: SettingsActionTypes.TOGGLE_DEACTIVATE_DIALOG,
});


/** ----------------------------------------------------------------------------
 * LINK EMAIL TO ACCOUNT
 -----------------------------------------------------------------------------*/

export const toggleEmailLinkDialog = () => ({
  type: SettingsActionTypes.TOGGLE_EMAIL_LINK_DIALOG,
});

export const toggleEmailUpdateDialog = () => ({
  type: SettingsActionTypes.TOGGLE_EMAIL_UPDATE_DIALOG,
});


/** ----------------------------------------------------------------------------
 * UPDATE EMAIL ADDRESS
 -----------------------------------------------------------------------------*/
export const updateEmailAddressRequested = () => ({
  type: SettingsActionTypes.UPDATE_EMAIL_REQUESTED,
  isUpdatingEmail: true,
});

export const updateEmailAddressSuccess = (response, emailAddress) => ({
  type: SettingsActionTypes.UPDATE_EMAIL_SUCCESS,
  isUpdatingEmail: false,
  isSuccess: response.isSuccess,
  message: response.message,
  emailAddress,
});

export const updateEmailAddressFailure = error => ({
  type: SettingsActionTypes.UPDATE_EMAIL_FAILURE,
  isUpdatingEmail: false,
  error: true,
  status: error.response && error.response.status,
});

export const updateEmailAddress = emailAddress => (dispatch) => {
  dispatch(updateEmailAddressRequested());

  return service.updateEmailAddress(emailAddress).then(
    response => dispatch(updateEmailAddressSuccess(response.data, emailAddress)),
    error => dispatch(updateEmailAddressFailure(error)),
  );
};

/** ----------------------------------------------------------------------------
 * Link Facebook/Twitter Account
 -----------------------------------------------------------------------------*/

export const linkSocialAccountSuccess = (result, account) => ({
  type: SettingsActionTypes.LINK_SOCIAL_ACCOUNT_SUCCESS,
  isLinking: false,
  isSuccess: result.isSuccess,
  message: result.message,
  accountType: account,
});

export const linkSocialAccountRequested = () => ({
  type: SettingsActionTypes.LINK_SOCIAL_ACCOUNT_REQUESTED,
  isLinking: true,
});

export const linkSocialAccountFailure = error => ({
  type: SettingsActionTypes.LINK_SOCIAL_ACCOUNT_FAILURE,
  isLinking: false,
  error: true,
  status: error.response && error.response.status,
});

export const linkFacebook = data => (dispatch) => {
  dispatch(linkSocialAccountRequested('facebook'));

  return service.linkFacebook(data).then(
    (response) => {
      dispatch(linkSocialAccountSuccess(response.data, 'facebook'));
    },
    error => dispatch(linkSocialAccountFailure(error, 'facebook')),
  );
};


export const closeAllModals = () => ({
  type: SettingsActionTypes.CLOSE_ALL_MODALS,
});